"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupLogout = exports.logoutFunc = void 0;
const app_1 = require("../../../app");
const local_storage_1 = require("../../../utils/local-storage");
function PopupLogout() {
    const popup = document.getElementById('popup');
    popup.classList.toggle('popup-open');
}
exports.PopupLogout = PopupLogout;
function logoutFunc() {
    (0, local_storage_1.clearStor)();
    const app = new app_1.App();
    app.run('login-page');
}
exports.logoutFunc = logoutFunc;
